/**
 * Shop-wide 5-star review strip. Port of src/components/ReviewsStrip.tsx.
 *
 * The section is rendered hidden and only revealed once reviews come back —
 * React returns null when there are none, and an empty bordered grid on the
 * homepage would look like a broken section.
 */
(function () {
  const root = document.querySelector('[data-cs-strip]');
  if (!root) return;

  const list = root.querySelector('[data-cs-strip-list]');
  const moreWrap = root.querySelector('[data-cs-strip-more-wrap]');
  const moreBtn = root.querySelector('[data-cs-strip-more]');
  const endpoint = root.dataset.endpoint;
  const anon = root.dataset.anon;
  const PAGE_SIZE = 6;
  const BODY_MAX = 190;

  let page = 0;
  let done = false;

  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"]/g, (c) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])
    );

  // truncateReviewBody() from ReviewsStrip.tsx, including the 0.72 rule that
  // avoids cutting a word almost at the limit.
  const truncate = (body) => {
    const n = String(body || '').replace(/\s+/g, ' ').trim();
    if (n.length <= BODY_MAX) return n;
    const slice = n.slice(0, BODY_MAX);
    const lastSpace = slice.lastIndexOf(' ');
    const cutoff = lastSpace > BODY_MAX * 0.72 ? lastSpace : BODY_MAX;
    return slice.slice(0, cutoff).replace(/[\s.,;:!?—-]+$/, '') + '…';
  };

  const card = (r) => {
    const map = window.csProductMap || {};
    const p = r.product_external_id ? map[String(r.product_external_id)] : null;
    return (
      '<article class="cs-ink bg-foreground text-background p-6 flex flex-col gap-3">' +
      '<div class="flex items-center gap-2 flex-wrap">' + window.csStars(r.rating, 16) + '</div>' +
      (r.title
        ? '<h3 class="tracking-tight text-xl md:text-2xl leading-[1]" style="font-family:\'Beleren\',\'Helvetica Neue\',sans-serif">' + esc(r.title) + '</h3>'
        : '') +
      '<p class="text-sm leading-relaxed font-light" style="font-family:\'Merriweather\',Georgia,serif">' + esc(truncate(r.body)) + '</p>' +
      '<div class="flex flex-col gap-1 mt-auto pt-1">' +
      '<p class="mono text-xs text-background/60">— ' + esc((r.reviewer && r.reviewer.name) || 'Anonymous') + '</p>' +
      (p
        ? '<a href="/products/' + esc(p.h) + '" class="link-fill mono text-xs font-bold tracking-tight self-start">' + esc(p.t) + '</a>'
        : '') +
      '</div></article>'
    );
  };

  const load = async () => {
    page += 1;
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: anon,
        Authorization: 'Bearer ' + anon,
      },
      body: JSON.stringify({ action: 'shop_reviews', per_page: PAGE_SIZE, rating: 5, page: page }),
    });
    if (!res.ok) return [];
    const data = await res.json();
    return (data && data.reviews) || [];
  };

  const render = (reviews) => {
    list.insertAdjacentHTML('beforeend', reviews.map(card).join(''));
    if (reviews.length < PAGE_SIZE) {
      done = true;
      moreWrap.hidden = true;
    } else {
      moreWrap.hidden = false;
    }
  };

  load()
    .then((reviews) => {
      if (!reviews.length) return; // section stays hidden, as React returns null
      root.hidden = false;
      render(reviews);
    })
    .catch(() => {});

  if (moreBtn) {
    moreBtn.addEventListener('click', async () => {
      if (done) return;
      moreBtn.disabled = true;
      try {
        render(await load());
      } finally {
        moreBtn.disabled = false;
      }
    });
  }
})();
